'use client'

import React from 'react'
import styles from './style.module.css'
import Helper from '../../../util/helper';
import SpinWrapper from '../../SpinWrapper/page';
import formatMsg from '../../../util/formatMsg';
import AdditionalFieldCard from '../../additionalFieldCard/page';
import LinkedAccountsMobileCard from './LinkedAccountsMobileCard/page';
import colors from '../../../libs/colorFactory';
import PrefixIconButton from '../../buttons/prefixIconButton';
import { getAllergyRows, getAuthorizedPickupRows, getEmergencyContactRows, getIllumineProfileRows, isIllumineOwned } from '../profileFields';
import { PlusOutlined } from "@ant-design/icons";
import RecurringAutopayInfo from '../../RecurringAutopayInfo/page';
import { hasPermissionForEntity, PERMISSIONS } from '../../../util/permissions';


const AccountProfileMobileView = (props: any) => {

  const {
    firebase,
    entityType,
    accountDetails,
    customFields,
    handleAddFieldForm,
    editBasicDetails,
    setLinkModalVisible,
    getStatusShowAndChangeDropdown,
    getAdditionalFieldDetails,
    getAccountName,
    getAccountEmail,
    isPrimaryAccount,
    getAccountPhoneNumber,
    getLinkStatus,
    showPopoverActions,
    getPopContent, 
    dataSource 
  } = props;

  const getEmptyState = () => {
    return (
      <div
        className={styles.noLinkedAccountsContainer}
      >
        <img
          src='/images/noLinkedAccounts.png'
          className={styles.noLinkedAccounts}
        />
      </div>
    )
  }

  return (accountDetails && Object.keys(accountDetails).length) &&
    (<div>
      <div className={styles.accountDetailsContainer}>
        <img
          src={Helper.getProfileImageUrl({ ...accountDetails })}
          className={styles.profilePhotoStyle}
        />
        <div className={styles.accountNameStyle}>
          <div className="global-page-header margin-left-4" >{accountDetails.name}</div>
          <div className={styles.accountStatusName}>
            {
              accountDetails.status
                ? getStatusShowAndChangeDropdown(accountDetails)
                : "-"
            }
          </div>
        </div>
        {/* Same gate as the laptop view: Illumine-owned records have no edit path, and
            editing is a permission the laptop view already required. */}
        {!accountDetails.migratedFromIllumine && hasPermissionForEntity(
          firebase,
          entityType === "account" ? PERMISSIONS.ACCOUNT_EDIT : PERMISSIONS.PARTICIPANT_EDIT,
          accountDetails.centerIds || []
        ) && (
          <div className={styles.editIconContainer}
            onClick={() => editBasicDetails(accountDetails)}
          >
            <img src="/images/pencil.png" className={styles.editIconStyle}></img>
          </div>
        )}
      </div>

      <div className={styles.accountDetailsContainer2}>
        {
          entityType === "account" &&
          <div className={styles.detailStyle}>
            <div>
              <div className={styles.profileLabelStyle}>{formatMsg("phoneNumber")}</div>
              <div className={styles.profileLabelStyle}>{formatMsg("email")}</div>
            </div>
            <div className={styles.valueContainer}>
              <div className={styles.profileValueStyle}>{accountDetails.phoneNumber ? accountDetails.phoneNumber : "-"}</div>
              <div className={styles.profileValueStyle}>{accountDetails.email ? accountDetails.email : "-"}</div>
            </div>
          </div>
        }
      </div>

      {entityType === "user" && isIllumineOwned(accountDetails) && (
        <div>
          <AdditionalFieldCard
            title={formatMsg("studentDetails")}
            fields={getIllumineProfileRows(accountDetails)}
            firebase={firebase}
            entity="accountOrUser"
            view="mobileCard"
          />
        </div>
      )}

      {Boolean(customFields?.length) &&
        <div>
          <AdditionalFieldCard
            title={formatMsg('accountDetails')}
            action={accountDetails.migratedFromIllumine
              ? undefined
              : () => handleAddFieldForm(entityType === "account" ? "accountAdditionalFields" : "userAdditionalFields")}
            fields={getAdditionalFieldDetails()}
            firebase={firebase}
            entity="accountOrUser"
            view="mobileCard"
          />
        </div>
      }

      {entityType !== "user" && accountDetails?.id && (
        <RecurringAutopayInfo accountId={accountDetails.id} style={{ marginTop: 24 }} />
      )}

      {/* Mirrored from Illumine, which owns them, and built from the same row helpers the
          laptop view uses so the two cannot drift. One card per record, and no `action` on
          any of them — the sync is their only writer, so there is nothing to edit here. */}
      {entityType === "user" && (accountDetails?.emergencyContacts || []).map((contact: any) => (
        <div key={contact.id}>
          <AdditionalFieldCard
            title={formatMsg("emergencyContacts")}
            fields={getEmergencyContactRows(contact)}
            firebase={firebase}
            entity="accountOrUser"
            view="mobileCard"
          />
        </div>
      ))}

      {entityType === "user" && (accountDetails?.allergies || []).map((allergy: any) => (
        <div key={allergy.id}>
          <AdditionalFieldCard
            title={formatMsg("allergies")}
            fields={getAllergyRows(allergy)}
            firebase={firebase}
            entity="accountOrUser"
            view="mobileCard"
          />
        </div>
      ))}

      {entityType === "user" && (accountDetails?.authorizedPickups || []).map((pickup: any) => (
        <div key={pickup.id}>
          <AdditionalFieldCard
            title={formatMsg("authorizedPickups")}
            fields={getAuthorizedPickupRows(pickup)}
            firebase={firebase}
            entity="accountOrUser"
            view="mobileCard"
          />
        </div>
      ))}

      {
        !Helper.isAccount(firebase) && entityType !== "user" ?
          <PrefixIconButton
            className={styles.accountLinkBtn}
            title={formatMsg("link")}
            backgroundColor={colors.v2_Cerulean}
            fontColor={colors.color_primarytext}
            width="100px"
            height="32px"
            marginTop="25px"
            prefixIcon={<PlusOutlined />}
            onClick={() => {
              setLinkModalVisible(true)
            }}
          /> : null
      }

      <LinkedAccountsMobileCard
        title={formatMsg('linkedAccounts')}
        entityType={entityType}
        getAccountName={getAccountName}
        getAccountEmail={getAccountEmail}
        isPrimaryAccount={isPrimaryAccount}
        getAccountPhoneNumber={getAccountPhoneNumber}
        getLinkStatus={getLinkStatus}
        showPopoverActions={showPopoverActions}
        getPopContent={getPopContent}
        getEmptyState={getEmptyState}
        dataSource={dataSource}
      />
    </div>)
}

export default AccountProfileMobileView